/**
 * CardContent
 * This is a wrapper component for Material-UI's `CardContent` providing a `surface` attribute to
 * adjust the background-color of the CardContent.
 */
import { default as MuiCardContent } from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
const useStyles = makeStyles(({ palette }) => ({
    inherit: { backgroundColor: 'inherit' },
    main: { backgroundColor: palette.background.default },
    light: { backgroundColor: palette.background.paper },
    dark: { backgroundColor: palette.divider },
}));
const CardContent = props => {
    const classes = useStyles();
    const { children, className, surface, ...rest } = props;
    return (React.createElement(MuiCardContent, Object.assign({ className: clsx(className, surface && classes[surface]) }, rest), children));
};
export default CardContent;
//# sourceMappingURL=CardContent.js.map